import { createAction } from "@reduxjs/toolkit";

export const showFullPageLoadingIndicator = createAction<void>('fullPageLoadingIndicator/show');

export const hideFullPageLoadingIndicator = createAction<void>('fullPageLoadingIndicator/hide');
